import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import EllipsisIcon from '@wix/da-ds/pkg/Icons/Ellipsis';
import IconButtonWithContextMenu from '@wix/da-ds/pkg/Dropdown/Preset/IconButtonWithContextMenu';
import { Url } from '@wix/da-url';

export interface Props {
  className?: string;
}

const GallerySettingsDropdown: FC<Props> = ({ className }) => {
  const { t } = useTranslation();

  const menuItems = [
    {
      label: t('galleryDisplaySettings.menuItem'),
      link: `${Url.studioGallery()}?settings=1`,
    },
  ];

  return (
    <IconButtonWithContextMenu
      icon={EllipsisIcon}
      withBackground
      items={menuItems}
      size={'medium'}
      aria-label={t('common.moreActions')}
      className={className}
    />
  );
};

GallerySettingsDropdown.displayName = 'GallerySettingsDropdown';

export default GallerySettingsDropdown;
